export const firebaseConfig = {
    apiKey: "AIzaSyAj5f9Yt3k1SguQc3bbqGoCDPtyHKNeM-0",
    authDomain: "dreamboard-62211.firebaseapp.com",
    projectId: "dreamboard-62211",
    storageBucket: "dreamboard-62211.appspot.com",
    messagingSenderId: "611061189232",
    appId: "1:611061189232:web:c27d09fb3fed71143ec2b5",
    measurementId: "G-QLT90P1R30",
};
